import { clsx } from "clsx";

export default function IconDownload({ className }: { className?: string }) {
  return (
    <svg
      className={clsx("", className)}
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0637 4.59473V20.1221L9.1106 15.1729L7.76685 16.5166L14.3293 23.0791L15.0012 23.7275L15.6731 23.0791L22.2356 16.5166L20.8918 15.1729L15.9387 20.1221V4.59473H14.0637ZM6.56372 25.2197V27.0947H23.4387V25.2197H6.56372Z"
        fill="currentColor"
      />
    </svg>
  );
}
